module.exports = __webpack_public_path__ + "img/home7.519563b1.png";